export function encodeHtmlEntities(value: string): string {
  return value.replace(/[\u00A0-\u9999<>&]/g, function (i) {
    return '&#' + i.charCodeAt(0) + ';';
  });
}
